import { Carousel } from "@ww-digital/prism";
import styles from "./styles.module.scss";

const PricingCarousel = ({ items, onSelect }) => {
  return (
    <div className={styles.carouselWrapper}>
      <Carousel
        carouselItems={items}
        carouselItemClassname="carouselSlideFlex"
        options={{
          gap: "24px",
          type: "slide",
          mediaQuery: "min",
          arrows: false,
          padding: { right: "50px" },
          fixedWidth: "327px", // Default width for mobile
          breakpoints: {
            991: {
              fixedWidth: "567px", // Width for desktop
              arrows: true
            }
          }
        }}
        className={styles.carousel}
        onActive={(_, slide) => onSelect(slide.index)}
      />
    </div>
  );
};

export default PricingCarousel;
